import { Check } from "lucide-react";

export const WhatIsThisSection: React.FC<{ data: any; theme: any }> = ({
  data,
  theme,
}) => {
  if (!data?.features || data.features.length === 0) return null;

  return (
    <section
      id="what-is-this"
      className="py-16 sm:py-20 bg-gradient-to-b from-white to-gray-50"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-gray-900">
            {data.sectionTitle || "What Is This?"}
          </h2>
          {data.description && (
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {data.description}
            </p>
          )}
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
          <div className="divide-y divide-gray-200">
            {[...data.features]
              .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
              .map((feature: any, i: number) => (
                <div key={i} className="p-6 hover:bg-gray-50 transition-colors">
                  <div className="flex items-start gap-4">
                    <div
                      className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold"
                      style={{
                        backgroundColor: theme?.primaryColor || "#10B981",
                      }}
                    >
                      <Check size={20} />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                        {feature.featureHeading}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {feature.featureText}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};
